// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"341":"88feedb1","804":"1d22a742","928":"0ca30718","7211":"88feedb1","7534":"0ca30718","9160":"5844dfd5"}[chunkId] + ".chunk.css";
};